import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog, TableBodySkeleton } from '../../common/components';
import BranchesDataTable from './components/BranchesDataTable';
import BranchesPagination from './components/BranchesPagination';
import BranchDialog from './components/BranchDialog';
import { useBranchesTable } from './hooks/useBranchesTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const BranchesTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedBranch,
    deleteConfirmOpen,
    branchToDelete,
    companies,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSave,
    handleEdit,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useBranchesTable();

  return (
    <Box>
      <FormTitleBox
        title="Administración | Sucursales"
        showButton={true}
        buttonText="Agregar Sucursal"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar sucursal"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <BranchesDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        LoadingComponent={TableBodySkeleton}
      />

      <BranchesPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <BranchDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedBranch={selectedBranch}
        onInputChange={handleInputChange}
        onSave={handleSave}
        companies={companies}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Eliminar Sucursal"
        message={`¿Está seguro que desea eliminar la sucursal "${branchToDelete?.name}" de la empresa "${branchToDelete?.company?.name}"?`}
        confirmText="Eliminar sucursal"
      />
    </Box>
  );
};

export default BranchesTable;
